import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { AppBar, Hidden, CircularProgress } from '@mui/material';
import { withStyles } from '@mui/styles';
import { withRouter } from 'react-router-dom';
import NavigationService from '../../../services/NavigationService';
import MobileNavbar from '../MobileNavbar/MobileNavbar';
import DesktopNavigation from '../DesktopNavigation/DesktopNavigation';
import UserContext from '../../../contexts/userContext';
import ActiveTokenRefresh from '../../GlobalComponents/ActiveTokenRefresh/ActiveTokenRefresh';

const styles = (theme) => ({
    root: {
        background: '#FFFFFF 0% 0% no-repeat padding-box',
        borderRadius: 3,
        boxShadow: '0px 3px 12px #0000000D',
        color: 'black',
        height: '60px',
        zIndex: 1300,
        [theme.breakpoints.up('md')]: {
            height: '80px',
        },
    },
    filler: {
        height: '80px',
        [theme.breakpoints.down('md')]: {
            height: '60px',
        },
    },
    progressWrapper: {
        height: '80vh',
    },
    progressRoot: {
        marginTop: '25vh',
    },
});

class Navbar extends Component {
    constructor(props, context) {
        super(props);
        this.state = {
            userLevelHasProcessed: false, // default the state to false that the user-level has not yet finished retrieving
        };
        this.context = context;
    }

    componentDidMount() {
        this.pollUserLevel();
        ActiveTokenRefresh.start();
    }

    componentWillUnmount() {
        ActiveTokenRefresh.stop();
        if (this.pollIntervalId) {
            clearInterval(this.pollIntervalId);
        }
    }

    pollUserLevel = () => {
        const { userLevel } = this.context;
        this.pollIntervalId = setInterval(() => {
            if (userLevel?.isFulfilled?.()) {
                this.userLevelFulfilled();
                clearInterval(this.pollIntervalId);
            }
        }, 250);
    };

    userLevelFulfilled = () => {
        this.setState({ userLevelHasProcessed: true });
    };

    render() {
        const { history, refreshNotifications } = this.props;
        if (history.location.pathname === '/') {
            return null;
        }
        const { classes } = this.props;
        const { userLevelHasProcessed } = this.state;
        const { account, userLevel } = this.context;

        if (userLevelHasProcessed === false) {
            return (
                <>
                    <AppBar className={classes.root}>
                        <div className={classes.progressWrapper}>
                            <CircularProgress color="primary" />
                        </div>
                    </AppBar>
                    <div className={classes.filler} />
                </>
            );
        }
        if (userLevelHasProcessed === true) {
            return (
                <>
                    <AppBar className={classes.root}>
                        <Hidden only={['md', 'lg', 'xl']}>
                            <MobileNavbar
                                refreshNotifications={refreshNotifications}
                                menuNavigation={
                                    account
                                        ? NavigationService.getHeaderLevelNavigation(
                                              userLevel.value()
                                          ).header
                                        : []
                                }
                            />
                        </Hidden>
                        <Hidden only={['xs', 'sm']}>
                            <DesktopNavigation
                                refreshNotifications={refreshNotifications}
                                menuNavigation={
                                    account
                                        ? NavigationService.getHeaderLevelNavigation(
                                              userLevel.value()
                                          ).header
                                        : []
                                }
                            />
                        </Hidden>
                    </AppBar>
                    <div className={classes.filler} />
                </>
            );
        }
    }
}

Navbar.propTypes = {
    classes: PropTypes.shape({
        root: PropTypes.string.isRequired,
    }).isRequired,
};

Navbar.contextType = UserContext;

export default withRouter(withStyles(styles)(Navbar));
